import { IJob } from 'kach-clients'
import { atom } from 'jotai'

export const jobsAtom = atom<{ jobs: IJob[] }>({ jobs: [] })
